const projectName = import.meta.env.VITE_PROJECT_NAME || 'auto-admin'

export enum localStorageKeys {
	token = 'token',
}

export const withdrawSoundKey = `${projectName}-WITHDRAW-SOUND`
